import React, {useContext, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import PrintIcon from "@material-ui/icons/Print";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import {Trad} from "src/components/";
import {CData} from "src/Data";
import {_Button, _ButtonAPI, _BondFormContent, _Derogation} from "../../components";
import useDerogation from "../../hooks/Derogation";
import useLimits from "../../hooks/Bond/Limits";
import {onPrint} from "./helpers";
import {IRouteParam} from "../../pages/Bond";
import {AlertDialogContext} from "../../providers/AlertDialogProvider";
import useToggle from "../../../hooks/Toggle";
import {_ChangeStatusDialog} from "./ChangeStatusDialog";

const Tax = 0.125;

export const _BondForm: React.FC = () => {
    const history = useHistory();
    const {open, toggle} = useToggle();
    const {ID_Anag, ID_FideAffidamento, ID_Polizza} = useParams<IRouteParam>();
    const {ShowDialog} = useContext(AlertDialogContext);
    const editingRights = Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura);
    const initialData = new Dati.CRisAPIDatoTipiInfo_Polizza();
    initialData.Dato.ID_AnagContraente = Number(ID_Anag);

    const [Data, setData] = useReducerOnChange<Dati.CRisAPIDatoTipiInfo_Polizza>(initialData);
    const [BondData, setBondData] = useReducerOnChange<any>({});
    const [coAssicurazioneJson, setCoAssicurazioneJson] = useState("");
    const [ProductBinder, setProductBinder] = useState("");
    const [Limits, setLimits] = useState<Dati.Dictionary<number>>({});
    const {DerogationFieldsList, OnChangeDerogation} = useDerogation();

    const LimitsUrl = `/api/polizza/GetLimiteImportoGarantito?id_AnagA=${ID_Anag}&id_FideAffidamento=${ID_FideAffidamento}&id_Polizza=${ID_Polizza}&dataEffetto=${
        Data.Dato.DataEffetto ? moment(Data.Dato.DataEffetto).utc().format() : ""
    }&id_TipoProdotto=${Data.Dato.ID_TipoProdotto}&id_AnagPOS=${Data.Dato.ID_AnagPOS}`;

    const {DerogationLimits, RiduzioneSommaGarantita, CalculateLimits} = useLimits(LimitsUrl);

    useEffect(() => {
        GetData();
    }, [ID_Anag, ID_Polizza]);

    useEffect(() => {
        if (ID_Polizza == '0' && Data.Dato.ID_TipoProdotto == 0) {
            GetNewPolicyData();
        }
    }, [Data.Dato.ID_TipoProdotto, ID_Polizza]);

    const isFakeDate = moment(Data.Dato.DataEmissione).utc().isSame("1901-01-01", "day");

    const dataEffetto = moment(
        isFakeDate ? Data.Dato.DataEffetto : Data.Dato.DataEmissione
    ).utc().format();

    useEffect(() => {
        GetProductBinder();
    }, [ID_FideAffidamento, Data.Dato.ID_TipoProdotto, dataEffetto]);

    console.warn("Data.Dato.DataEmissione", Data.Dato.DataEmissione);

    useEffect(() => {
        setLimits(CalculateLimits(Data.Dato.CoAssicurazioneJSON, ProductBinder));
    }, [Data.Dato.CoAssicurazioneJSON, ProductBinder, DerogationLimits]);

    const session = Glob.GetSessione();

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/?id_Polizza=${ID_Polizza}&id_AnagContraente=${ID_Anag}`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        if (data.Tipi["BinderProdotto"].BinderProdotto.Valore) {
            setProductBinder(data.Tipi["BinderProdotto"].BinderProdotto.Valore);
        }
        if (data.ID_Chiave > 0) {
            const newPolicy: any = Glob.CreaClassePolizzaFide(data.Info);
            const policyData: any = JSON.parse(data.Dato.DatiPolizza);

            for (let key in newPolicy) {
                if (policyData[key] != undefined) {
                    newPolicy[key] = policyData[key];
                }
                if (key == "ImpegnoRilascio" && newPolicy[key] == "") {
                    newPolicy[key] = true;
                }
            }
            setData({Type: "Set", Value: data});
            setBondData({Type: "Set", Value: newPolicy});
            setCoAssicurazioneJson(data.Dato.CoAssicurazioneJSON);
        }
    };

    const GetNewPolicyData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/GetInfoPolizza?ID_TipoProdotto=${Data.Dato.ID_TipoProdotto}`,
            OnRis: OnGetNewPolicyData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetNewPolicyData = (sender: ChiamaWeb, data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        let emptyPolicy: Dati.CRisAPIDatoTipiInfo_Polizza = new Dati.CRisAPIDatoTipiInfo_Polizza();
        emptyPolicy.Info = data.Info;
        emptyPolicy.Dato = Data.Dato;

        let newPolicy: any = Glob.CreaClassePolizzaFide(data.Info);
        newPolicy.LuogoEsecuzione = "Vedasi oggetto garanzia";
        if (
            Data.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaLavori ||
            Data.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaForniture ||
            Data.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaServizi
        ) {
            const duration = 180;
            const reliefDate = new CData(moment(Data.Dato.DataEffetto).toDate(), true).AddGiorni(duration).Data;

            newPolicy.Durata = duration;
            newPolicy.DataSvincolo = reliefDate;
            emptyPolicy.Dato.DataFine = reliefDate;
        }
        setData({Type: "Set", Value: emptyPolicy});
        setBondData({Type: "Set", Value: newPolicy});
    };

    const GetProductBinder = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/GetFideBinderProdotto?id_FideAffidamento=${ID_FideAffidamento}&id_TipoProdotto=${Data.Dato.ID_TipoProdotto}&dataEffetto=${moment(dataEffetto).utc().format()}`,
            OnRis: OnGetProductBinder,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetProductBinder = (sender: ChiamaWeb, data: Dati.CRisAPISemplice<string>) => {
        setData({Type: "OnChangeFromValue", Name: "Dato.CoAssicurazioneJSON", Value: GetSingleInsurance(data.Dato)});
        setProductBinder(data.Dato);
    };

    const GetSingleInsurance = (productBinderJSON: string): string => {
        if (productBinderJSON) {
            const productBinder: Dati.CDatoBinderProdottoCoAssicurazione[] = JSON.parse(productBinderJSON);

            if (productBinder.length == 1) {
                const coInsurance = new Dati.CDatoCoAssicurazione();
                coInsurance.Delegataria = true;
                coInsurance.Quota = 100;
                coInsurance.ID_Anag = productBinder[0].ID_AnagCompagnia;
                coInsurance.ID_Binder = productBinder[0].ID_Binder;
                coInsurance.ID_BinderCompagnia = productBinder[0].ID_BinderCompagnia;

                return JSON.stringify([coInsurance]);
            }
        }

        return "";
    };

    const GetFormData = (calculate = false, newState = ""): Dati.CIngrAPI<Dati.CDatiPolizza> => {
        const formData = new Dati.CIngrAPI<Dati.CDatiPolizza>();

        formData.Dato = Data.Dato;
        formData.Dato.ID_AnagContraente = Number(ID_Anag);
        formData.Dato.ID_Polizza = Number(ID_Polizza);
        formData.Dato.ID_TipoRamo = Glob.TipiRami_Fideiussioni;
        formData.Dato.DatiPolizza = JSON.stringify({...BondData, ID_FideAffidamento: ID_FideAffidamento});
        
        if (newState != "")
        {
            formData.Dato.ID_TipoPolizzaStato = newState;
        }

        return formData;
    };

    const OnClickSave = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            if (ID_Polizza == "0") {
                history.push(`/anagrafica/${ID_Anag}/fideaffidamento/${ID_FideAffidamento}/FidePolizza/${data.ID_Chiave}`);
            }
            const savedData = {...Data};

            savedData.Dato.ID_Polizza = data.ID_Chiave;
            savedData.Dato.Polizza = data.MessaggioTesto;
            savedData.Dato.ContraenteATI = data.MessaggioDati[0];
            savedData.Dato.ID_TipoFileRichiesto = data.MessaggioDati[1];

            setData({Type: "Set", Value: savedData});
            ShowDialog("POLIZZA", Trad.TradParam("Polizza salvata correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
            GetData();
        }
    };

    const OnClickSaveAddenda = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            ShowDialog("APPENDICI", Trad.TradParam("Appendice salvata correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
            history.push(`/anagrafica/${ID_Anag}/fideaffidamento/${ID_FideAffidamento}/FidePolizza/${data.ID_Chiave}`);
            GetData();
        }
    };

    const OnClickRejection = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            if (ID_Polizza == "0") {
                history.push(`/anagrafica/${ID_Anag}/fideaffidamento/${ID_FideAffidamento}/FidePolizza/${data.ID_Chiave}`);
            }
            ShowDialog("POLIZZA", "Polizza rifiutata correttamente", "success");
            GetData();
        }
    };
    
    const OnClickChangeState = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            if (ID_Polizza == "0") {
                history.push(`/anagrafica/${ID_Anag}/fideaffidamento/${ID_FideAffidamento}/FidePolizza/${data.ID_Chiave}`);
            }
            ShowDialog("POLIZZA", "Polizza salvata correttamente", "success");
            GetData();
        }
    };
    
    const OnClickCalculate = (data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        OnRecalculateExtensions(data);
        if (!data.Errore) {
            ShowDialog("Info", Trad.Trad("Premio calcolato correttamente"), "success");
        }
    };

    const UseTendersDatabase = (data: Dati.CBancaDatiGare) => {
        setData({Type: "OnChangeFromValue", Name: "Dato.DataEffetto", Value: data.DataPresentazione || ""});
        setBondData({
            Type: "Set",
            Value: {
                ...BondData,
                DataGara: data.DataGara,
                DataPresentazione: data.DataPresentazione,
                ImportoComplessivo: data.ImportoComplessivo,
                OggettoGaranzia: data.OggettoGaranzia,
                RibassoAsta: data.RibassoAsta || 0
            }
        });
    };

    const OnBlurAmount = () => {
        const newPolicy = {...BondData};
        const hasExtensions = Object.keys(Data.Info).some(item => Data.Info[item].Campo == "ProrogheAccessori" || Data.Info[item].Campo == "ProrogheDa");

        if (BondData.PremioNetto < Limits["PremioNettoMIN"] || BondData.PremioNetto > Limits["PremioNettoMAX"]) {
            const premioNetto = BondData.PremioNetto < Limits["PremioNettoMIN"] ? Limits["PremioNettoMIN"] : Limits["PremioNettoMAX"];
            const warningMessage = BondData.PremioNetto < Limits["PremioNettoMIN"] ? "PremioImpostatoInferioreAlPremioMinimo" : "PremioImpostatoSuperioreAlLimite";

            newPolicy.PremioNetto = premioNetto;
            newPolicy.Imponibile = premioNetto + (newPolicy.Accessori * premioNetto) / 100 + newPolicy.DirittiEmissione;
            newPolicy.Imposte = newPolicy.Imponibile * Tax;
            newPolicy.PremioFinito = newPolicy.Imponibile + newPolicy.Imposte;

            setBondData({Type: "Set", Value: newPolicy});
            ShowDialog("WARNING", Trad.Trad(warningMessage), "warning");
        } else {
            let ImponibileCalcolato: number = BondData.PremioNetto + (BondData.PremioNetto * BondData.Accessori) / 100 + BondData.DirittiEmissione;

            if (Math.abs(BondData.Imponibile - ImponibileCalcolato) >= 0.01) {
                ShowDialog(
                    "WARNING",
                    Trad.TradParam("ImponibileCalcolato{1-I}ImponibileInseritoDifferenti{2-I}Differenza{3-I}", [ImponibileCalcolato, BondData.Imponibile, BondData.Imponibile - ImponibileCalcolato]),
                    "warning"
                );
            }
        }

        if (hasExtensions) {
            RecalculateExtensions();
        }
    };

    const OnChangeAmount = (e: string, val: string) => {
        const newPolicy = {...BondData};
        const value = Number(val);

        switch (e) {
            case "PremioNetto":
                newPolicy.Imponibile = value + (newPolicy.Accessori * value) / 100 + newPolicy.DirittiEmissione;
                newPolicy.Imposte = newPolicy.Imponibile * Tax;
                newPolicy.PremioFinito = newPolicy.Imponibile + newPolicy.Imposte;
                break;
            case "DatoFidePolizza.Accessori":
                newPolicy.Imponibile = newPolicy.PremioNetto + (value * newPolicy.PremioNetto) / 100 + newPolicy.DirittiEmissione;
                newPolicy.Imposte = newPolicy.Imponibile * Tax;
                newPolicy.PremioFinito = newPolicy.Imponibile + newPolicy.Imposte;
                break;
            case "DatoFidePolizza.DirittiEmissione":
                newPolicy.Imponibile = newPolicy.PremioNetto + (newPolicy.Accessori * newPolicy.PremioNetto) / 100 + value;
                newPolicy.Imposte = newPolicy.Imponibile * Tax;
                newPolicy.PremioFinito = newPolicy.Imponibile + newPolicy.Imposte;
                break;
            case "DatoFidePolizza.Imponibile":
                newPolicy.Imposte = value * Tax;
                newPolicy.PremioFinito = value + newPolicy.Imposte;
                break;
            case "DatoFidePolizza.Imposte":
                newPolicy.Imponibile = value / Tax;
                newPolicy.PremioFinito = newPolicy.Imponibile + value;
                break;
            case "DatoFidePolizza.PremioFinito":
                newPolicy.Imposte = value / (1 / Tax + 1);
                newPolicy.Imponibile = value / (1 + Tax);
                newPolicy.PremioNetto = (newPolicy.Imponibile - newPolicy.DirittiEmissione) / ((100 + newPolicy.Accessori) / 100);
                break;
        }
        newPolicy[e] = val;
        setBondData({Type: "Set", Value: newPolicy});
    };

    const RecalculateExtensions = () => {
        const Param: CChiamaWebParametri = {
            URL: "/api/polizza/FideCalcolaProroghe",
            Metodo: "POST",
            OnRis: (sender, data) => OnRecalculateExtensions(data),
            OnInvio: () => GetFormData(true),
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnRecalculateExtensions = (data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            const newBondData = JSON.parse(data.Dato.DatiPolizza);

            setLimits({...Limits, PremioNettoMAX: newBondData.PremioFinito * 2});
            setData({Type: "Set", Value: data});
            setBondData({Type: "Set", Value: newBondData});
        }
    };

    const ParametersChangeState: { [Param: string]: any } = [];
    ParametersChangeState["id_Polizza"] = ID_Polizza;
    ParametersChangeState["allRecords"] = false;

    const isFormValid = true;
    const isPreventivo = Data.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo
        || Data.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_PreventivoBozzaInviata
        || Data.Dato.ID_TipoPolizzaStato == ""
    const showActionButtons = Data.Dato.ID_TipoPolizzaStato != Glob.Tipi_PS_Rifiuto && isPreventivo;
    const showChangeStateButtons = Data.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_Emessa 
        || Data.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_Variata 
        || Data.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_Prorogata;
    return (
        <Card>
            <CardContent>
                <form noValidate autoComplete="off">
                    <_BondFormContent
                        Data={Data}
                        BondData={BondData}
                        CoAssicurazioneJson={coAssicurazioneJson}
                        Limits={Limits}
                        ProductBinderJSON={ProductBinder}
                        RiduzioneSommaGarantita={RiduzioneSommaGarantita}
                        OnBlurAmount={OnBlurAmount}
                        OnChangeAmount={OnChangeAmount}
                        OnChangeDerogation={OnChangeDerogation}
                        OnChangeBondData={(e, val) => setBondData({Type: "OnChangeFromValue", Name: e, Value: val})}
                        GetFormData={GetFormData}
                        OnChange={(e, val) => setData({
                            Type: "OnChangeFromHybrid",
                            NameEvent: val != null && val != undefined ? e : Object.assign({}, e),
                            Value: val
                        })}
                        OnClickSaveAddenda={OnClickSaveAddenda}
                        OnApiError={OnApiError}
                        UseTendersDatabase={UseTendersDatabase}
                    />
                </form>
                <_ChangeStatusDialog Open={open} ID_Polizza={ID_Polizza} GetData={GetData} OnClose={toggle}/>
            </CardContent>

            <CardActions disableSpacing>
                <Grid item container xs={12} spacing={3} justify="flex-end">
                    {editingRights && (
                        <>
                            {isPreventivo &&(
                            <Grid item>
                                <_ButtonAPI Testo={Trad.Trad("Rifiuto")}
                                            URL="/api/polizza/salvapolizza"
                                            OnInvio={() => GetFormData(false, Glob.Tipi_PS_Rifiuto)}
                                            OnClick={OnClickRejection}
                                            OnErrore={OnApiError}
                                            Default={false}
                                />
                            </Grid>
                            )}
                            {showChangeStateButtons && (
                                <>
                                    <Grid item>
                                        <_Button Testo={Trad.Trad("Svincolo")} OnClick={toggle} Default={false}
                                                 WithWrapper={false}/>
                                    </Grid>
                                    {Data.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_Emessa && (
                                        <Grid item>
                                            <_ButtonAPI Testo={Trad.Trad("Rimetti in preventivo")}
                                                        URL="/api/polizza/ChangeStateToDraft" Metodo="POST"
                                                        ParamURLLista={ParametersChangeState} OnClick={OnClickChangeState}
                                                        OnErrore={OnApiError}/>
                                        </Grid>
                                    )}  
                                </>
                            )}
                            <Grid item>
                                <_ButtonAPI Default Attivo={isFormValid} Testo={Trad.Trad("Salva")}
                                            URL="/api/polizza/salvapolizza" OnInvio={GetFormData} OnClick={OnClickSave}
                                            OnErrore={OnApiError}/>
                            </Grid>
                            <Grid item>
                                <_ButtonAPI Default Attivo={isFormValid} Testo={Trad.Trad("Salva (bozza inviata)")}
                                            URL="/api/polizza/salvapolizza" OnInvio={() => GetFormData(false, Glob.Tipi_PS_PreventivoBozzaInviata)}
                                            OnClick={OnClickSave} OnErrore={OnApiError}/>
                            </Grid>
                            <Grid item>
                                <_ButtonAPI Testo={Trad.Trad("Calcola")} URL="/api/polizza/fidecalcola"
                                            OnInvio={() => GetFormData(true)} OnClick={OnClickCalculate}
                                            OnErrore={OnApiError}/>
                            </Grid>
                        </>
                    )}
                    {!showActionButtons && (
                        <Grid item>
                            <_Button Testo={Trad.Trad("Stampa")} Icona={<PrintIcon/>}
                                     OnClick={() => onPrint(false, Data.Dato)} Default={false} WithWrapper={false}/>
                        </Grid>
                    )}
                    {showActionButtons && (
                        <Grid item>
                            <_Button Testo={Trad.Trad("Stampa bozza")} Icona={<PrintIcon/>}
                                     OnClick={() => onPrint(true, Data.Dato)} Default={false} WithWrapper={false}/>
                        </Grid>
                    )}
                    {Number(ID_Polizza) > 0 && Object.keys(DerogationFieldsList).length > 0 &&
                        <_Derogation Data={DerogationFieldsList} Id={Number(ID_Polizza)} Type={Glob.Tipi_DT_Polizza}/>}
                </Grid>
            </CardActions>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/Bond/BondForm.tsx